import { observable } from 'rewire-core';

export class SideTogglePanelModel {
  state: {
    isOpen:             boolean;
    isSetOpen:          boolean;
    isLocked:           boolean;
    __SidePanelContent: any | null; // Don't make React Elements observable!!!
  };

  constructor() {
    this.state = observable({
      isOpen:             true,
      isSetOpen:          true,
      isLocked:           false,
      __SidePanelContent: null
    });
  }

  get isOpen(): boolean {
    return this.state.isOpen;
  }

  get SidePanelContent(): any | null {
    return this.state.__SidePanelContent;
  }

  set SidePanelContent(value: any | null) {
    this.state.__SidePanelContent = value;
  }

  get isSetOpen(): boolean {
    return this.state.isSetOpen;
  }

  get isLocked(): boolean {
    return this.state.isLocked;
  }

  open() {
    this.state.isOpen    = true;
    this.state.isSetOpen = true;
  }

  close() {
    this.state.isOpen    = false;
    this.state.isSetOpen = false;
  }

  forceOpen() {
    this.state.isOpen = true;
  }

  forceClose() {
    this.state.isOpen = false;
  }

  lock() {
    this.state.isLocked = true;
  }

  unlock() {
    this.state.isLocked = false;
  }
}

const sideTogglePanelModel = new SideTogglePanelModel();
export default sideTogglePanelModel;
